import { useContext } from "react";
import { Link } from "react-router-dom";
import { getIndependentSymbol, getPercentage, getTimeAgo, translate, translateNumber, translatePercentage } from "../../../helper";
import { ASSET_HOST_BASE_URL, otherParty, POPULAR_REGIONS_FEDERAL_2079, POPULAR_REGIONS_PROVINCIAL_2079 } from "../../../config";
import LangContext from "../../../contexts/LangContext";
import Tab from "../../common/Tab";
import { LoaderInner } from "../../common/Loader";
import "./index.css";

const BattleGround = (props) => {
  const { lang } = useContext(LangContext);
  const { tab, data, provinces, parties } = props;
  const bgRegions = [];

  let battleGrounds = [];

  if (tab === "provincial") {
    battleGrounds = POPULAR_REGIONS_PROVINCIAL_2079.battle_grounds;
  } else {
    battleGrounds = POPULAR_REGIONS_FEDERAL_2079.battle_grounds;
  }

  data.provinces.forEach((prov) => {
    prov.districts.forEach((dist) => {
      dist.regions.forEach((reg) => {
        let regionFixed = 0;
        if (reg.rtype === "provincial") {
          regionFixed = 1;
        }
        const region_code = dist.id + "-" + parseFloat(reg.id).toFixed(regionFixed);
        const BattleGround = battleGrounds.find((pr) => pr.region === region_code);
        if (reg.rtype === tab && BattleGround) {
          reg.district_id = dist.id;
          reg.battle_info = BattleGround;
          bgRegions.push(reg);
        }
      });
    });
  });

  let regionData = [];
  regionData = bgRegions.map((region) => {
    if (!region.result) return [];
    let rData = JSON.parse(JSON.stringify(region));
    rData.total = rData.result.reduce((a, b) => a + b.vote, 0);
    if (!rData.result.find((r) => r.vote > 0)) {
      rData.result = rData.result.sort((a, b) => {
        if (b.name_en < a.name_en) return 1;
        else return -1;
      });
    }
    const elected = rData.result.find((a) => a.elected);
    const followings = rData.result.filter((a) => !a.elected).sort((a, b) => b.vote - a.vote);

    rData.result = elected ? [elected, ...followings] : [...followings];

    let bgCandidates = [];
    bgCandidates = region.battle_info.parties.map((bp) => {
      const candidate = rData.result.find((r) => r.party.toLowerCase() === bp.toLowerCase());
      return candidate ? candidate : rData.result[0];
    });

    rData.result = bgCandidates.length > 0 ? [...bgCandidates] : [...rData.result];

    return rData;
  });

  let updatedAt = new Date("2022-11-20T23:59:59");
  regionData.forEach((r) => {
    if (r.result) {
      r.result.forEach((res) => {
        if (updatedAt < new Date(res.updated_at)) {
          updatedAt = new Date(res.updated_at);
        }
      });
    }
  });

  const eastToWesRegions = [];
  provinces.forEach((p) => {
    p.districts.forEach((d) => {
      d.regions.forEach((r) => {
        let regionFixed = 0;
        if (r.rtype === "provincial") {
          regionFixed = 1;
        }
        const region_code = d.id + "-" + parseFloat(r.id).toFixed(regionFixed);
        if (r.rtype === tab && battleGrounds.find((pr) => pr.region === region_code)) {
          r.province_id = p.id;
          r.district_id = d.id;
          r.region_code = region_code;
          r.dist_name_np = d.name_np;
          r.dist_name_en = d.name_en;
          eastToWesRegions.push(r);
        }
      });
    });
  });

  const wtBasedRegions = battleGrounds
    .map((reg) => {
      const region = eastToWesRegions.find((r) => r.region_code === reg.region);
      return region;
    })
    .filter((a) => a);

  return (
    <>
      {props.showtab ? <Tab tab={tab} handleTabChange={props.handleTabChange} /> : ""}
      <section id="sh-hot-seat-summary" className="sh-summary-section">
        <div className="container">
          {!props.fetched ? (
            <LoaderInner />
          ) : (
            <div className="container-fluid-removed card-removed sh-card-summary">
              <div className="row">
                <div className="col-md-12 mb-3">
                  <span className="float-end">
                    {translate("last_updated", lang)}: &nbsp;{translateNumber(getTimeAgo(updatedAt).time, lang)} {translate(getTimeAgo(updatedAt).metrics, lang)} {translate("ago", lang)}
                  </span>
                  <h3>{translate("battle_grounds_title", lang)}</h3>
                </div>
                {wtBasedRegions.map((reg, i) => {
                  const rData = regionData.find((r) => r && r.district_id === reg.district_id && r.id && r.id === reg.id);
                  const sortedResult = rData ? rData.result.sort((r, s) => s.vote - r.vote) : null;
                  const diff = sortedResult[0].vote - sortedResult[1].vote;

                  return (
                    <div key={i} className="col-xl-4 col-md-6 col-sm-6">
                      <div className="sh-widget-card card">
                        <h4>
                          <Link to={"/result/" + reg.province_id + "/" + reg.district_id + "/" + reg.id.toFixed(0) + "?type=" + tab + "&lang=" + lang}> {reg["dist_name_" + lang] + ": " + reg["name_" + lang]}</Link>
                          <span className="sh-region-total-voter">{translate("total_voter", lang) + ": " + translateNumber(reg.total_voter, lang)}</span>
                        </h4>

                        <h4 className="text-center">{rData && <span className={rData.declared ? "sh-count-done" : "sh-counting"}> {rData.declared ? translate("count_done", lang) : rData.result.find((r) => r.vote > 0) ? translate("couting", lang) : ""}</span>}</h4>
                        {sortedResult &&
                          sortedResult.map((d, j) => {
                            const party = parties.find((par) => par.code === d.party || (d.party.match(/I+\d/) && par.code === "I")) || otherParty;
                            let symbol = party.code.toUpperCase();
                            if (symbol === "I") {
                              symbol = getIndependentSymbol(reg.district_id, reg.id, d.name_en);
                            }
                            const gender = d.gender ? d.gender : "O";

                            return (
                              <div key={j}>
                                <div className="sh-candidate-info">
                                  <div className={"sh-candidate-photo-wrapper" + (!!d.elected ? " sh-highlight-rotate" : "")}>
                                    <img
                                      src={ASSET_HOST_BASE_URL + "/images/parties/" + symbol + ".png"}
                                      alt={party.code.toUpperCase()}
                                      onError={({ currentTarget }) => {
                                        currentTarget.onerror = null; // prevents looping
                                        currentTarget.src = ASSET_HOST_BASE_URL + "/images/parties/O.png";
                                      }}
                                      className="pull-left sh-party-symbol-inner"
                                      width="24px"
                                      height="24px"
                                    />
                                    <img
                                      src={ASSET_HOST_BASE_URL + "/images/candidates/" + reg.district_id + "/" + reg.id + "/" + party.code.toLowerCase() + "-" + d.name_en.toLowerCase().replaceAll(" ", "-") + ".jpg"}
                                      alt={party.code.toUpperCase()}
                                      onError={({ currentTarget }) => {
                                        currentTarget.onerror = null; // prevents looping
                                        currentTarget.src = ASSET_HOST_BASE_URL + "/images/candidates/dummy-" + gender + ".jpg";
                                      }}
                                      className="pull-left sh-candidate-photo"
                                      width="50px"
                                      height="50px"
                                      style={!!d.elected ? { border: "2px solid " + party.color, padding: "2px" } : {}}
                                    />
                                  </div>
                                  <div className="sh-candidate-name">
                                    <Link to={"/candidates/profile/" + d.cid + "?lang=" + lang}>{d["name_" + lang]}</Link>
                                    <br />
                                    <span className="sh-gender-age-party">
                                      <Link to={"/candidates/" + party.code + "?lang=" + lang}>{party["short_name_" + lang] ? party["short_name_" + lang] : party["name_" + lang]}</Link> - {translate(d.gender === "M" ? "male" : d.gender === "F" ? "female" : "other", lang) + ", " + translateNumber(d.age, lang) + " " + translate("years", lang)}
                                    </span>
                                  </div>
                                  <span className="sh-banner-winner">{!!rData.declared && <img src={ASSET_HOST_BASE_URL + "/images/congrats.png"} alt="winner" width="50px" height="43px" />}</span>
                                  <span className="sh-winner data">
                                    {j === 0 && <label className="sh-vote-diff">{"(" + translate("diff", lang) + ": " + translateNumber(diff, lang) + ")"}</label>}&nbsp;
                                    {translateNumber(d.vote, lang)}
                                    <span>{j === 0 && rData.declared ? translate("elected", lang) + " " : ""}</span>
                                  </span>
                                </div>

                                <div className="progress">
                                  <div className={"progress-bar progress-bar-striped" + (rData.declared ? "" : " progress-bar-animated")} role="progressbar" style={{ width: getPercentage(d.vote, rData.total), backgroundColor: party.color }}>
                                    {translatePercentage(d.vote, rData.total, lang)}
                                  </div>
                                </div>
                              </div>
                            );
                          })}
                        <div className="sh-view-all">
                          <span>
                            <Link to={"/result/" + reg.province_id + "/" + reg.district_id + "/" + reg.id.toFixed(0) + "?type=" + tab + "&lang=" + lang}>{translate("view_all", lang)}</Link>
                          </span>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          )}
        </div>
      </section>
    </>
  );
};

export default BattleGround;
